import { translateFunc } from "@/utils/translateFunc";

const useAccountMessages = () => {
    const messages: any = {
        "invalid-email": translateFunc("invalid-email"),
        "min-password": translateFunc("min-password"),
        "max-password": translateFunc("max-password"),
        "confirm-pass-not-matched": translateFunc("confirm-pass-not-matched"),
        "required-lowercase": translateFunc("required-lowercase"),
        "required-uppercase": translateFunc("required-uppercase"),
        "required-number": translateFunc("required-number"),
        "required-special-char": translateFunc("required-special-char"),
        "signup-success": translateFunc("signup-success"),
        "login-success": translateFunc("login-success"),
        "login-failed": translateFunc("login-failed"),
        "user-not-found": translateFunc("user-not-found"),
        "invalid-credentials": translateFunc("invalid-credentials"),
        "user-is-blocked": translateFunc("user-is-blocked"),
        "limit-exceeded": translateFunc("limit-exceeded"),
        "email-verification-success": translateFunc("email-verification-success"),
        "password-reset-success": translateFunc("password-reset-success"),
        "password-change-success": translateFunc("password-change-success"),
        "email-verified": translateFunc("email-verified"),
        "email-verification-email-sent": translateFunc("email-verification-email-sent"),
        "password-reset-instructions-sent": translateFunc("password-reset-instructions-sent"),
        "token-expired": translateFunc("token-expired"),
        "user-already-exists": translateFunc("user-already-exists"),
        "invalid-session": translateFunc("invalid-session"),
        "password-reset-failed": translateFunc("password-reset-failed"),
        "invalid-recaptcha": translateFunc("invalid-recaptcha"),
        "recaptcha-verification-failed": translateFunc("recaptcha-verification-failed"),
        "error": translateFunc("error"),
        "account-locked": translateFunc("account-locked", { durationInMin: "durationInMin" }),
    };

    const getValMsg = (key: string | undefined, alternate?: string) => {
        if (key && messages[key]) {
            return messages[key] ?? alternate;
        }
        return alternate;
    };

    return { getValMsg };
};

export default useAccountMessages;

